'use strict';

angular.module('internal.services')
    .controller('InternalServiceCertificationRequirements', ['$scope', 'ServiceUserCertificationRequirements', function ($scope, ServiceUserCertificationRequirements) {
        $scope.resetService();

        $scope.serviceLoading = true;
        $scope.saving = false;
        $scope.positionRows = [];
        $scope.certificationRequirements = {
            positions: [],
            userEntityLicenseCategoryLevels: [],
            positionSelectedLicenseCategoryLevelIds: {}
        };

        function getDictionaryValue(dictionary, key) {
            if (!dictionary || !key) {
                return null;
            }

            if (dictionary[key]) {
                return dictionary[key];
            }

            var target = key.toString().toLowerCase();
            var keys = Object.keys(dictionary);
            for (var i = 0; i < keys.length; i++) {
                if (keys[i] && keys[i].toLowerCase() === target) {
                    return dictionary[keys[i]];
                }
            }

            return null;
        }

        function sortOptionsByName(options) {
            if (!angular.isArray(options)) {
                return [];
            }

            return options.slice().sort(function (left, right) {
                var leftName = ((left && left.name) || '').toLowerCase();
                var rightName = ((right && right.name) || '').toLowerCase();

                if (leftName < rightName) {
                    return -1;
                }

                if (leftName > rightName) {
                    return 1;
                }

                return 0;
            });
        }

        function mapIdsToOptions(ids, options) {
            if (!angular.isArray(ids) || !angular.isArray(options)) {
                return [];
            }

            var byId = {};
            options.forEach(function (option) {
                if (option && option.id) {
                    byId[option.id.toString().toLowerCase()] = option;
                }
            });

            var selected = [];
            ids.forEach(function (id) {
                if (!id) {
                    return;
                }

                var match = byId[id.toString().toLowerCase()];
                if (match) {
                    selected.push(match);
                }
            });

            return sortOptionsByName(selected);
        }

        function mapOptionsToIds(options) {
            if (!angular.isArray(options)) {
                return [];
            }

            var ids = [];
            options.forEach(function (option) {
                if (option && option.id) {
                    ids.push(option.id);
                }
            });

            return ids;
        }

        function buildPositionRows() {
            var options = sortOptionsByName($scope.certificationRequirements.userEntityLicenseCategoryLevels || []);
            var selectedMap = $scope.certificationRequirements.positionSelectedLicenseCategoryLevelIds || {};
            var requiredMap = $scope.certificationRequirements.positionRequiredLicenseCategoryLevelIds || {};
            var preferredMap = $scope.certificationRequirements.positionPreferredLicenseCategoryLevelIds || {};

            $scope.certificationRequirements.userEntityLicenseCategoryLevels = options;

            $scope.positionRows = ($scope.certificationRequirements.positions || []).map(function (position, index) {
                var positionId = position.id;
                var selectedIds = getDictionaryValue(selectedMap, positionId) || [];

                var requiredIds = getDictionaryValue(requiredMap, positionId);
                var preferredIds = getDictionaryValue(preferredMap, positionId);

                if (!angular.isArray(requiredIds) && !angular.isArray(preferredIds)) {
                    requiredIds = selectedIds;
                    preferredIds = [];
                }

                return {
                    position: position,
                    positionName: position.name || position.nameandnumber || position.label || positionId,
                    positionLabel: position.name || position.nameandnumber || position.label || ('Position ' + (index + 1)),
                    requiredSelections: mapIdsToOptions(requiredIds || [], options),
                    preferredSelections: mapIdsToOptions(preferredIds || [], options)
                };
            });

            $scope.hasAnySelectedValues = Object.keys(selectedMap).length > 0;
        }

        ServiceUserCertificationRequirements.getServiceUserCertificationRequirements($scope.serviceID)
            .then(function (data) {
                $scope.certificationRequirements = data || $scope.certificationRequirements;
                buildPositionRows();
            })
            .finally(function () {
                $scope.serviceLoading = false;
            });

        $scope.save = function () {
            $scope.saving = true;

            var positionRequirements = $scope.positionRows.map(function (row) {
                return {
                    positionId: row.position && row.position.id,
                    requiredLicenseCategoryLevelIds: mapOptionsToIds(row.requiredSelections),
                    preferredLicenseCategoryLevelIds: mapOptionsToIds(row.preferredSelections)
                };
            });

            ServiceUserCertificationRequirements.saveServiceUserCertificationRequirements($scope.serviceID, {
                positionRequirements: positionRequirements
            }).then(function () {
                return ServiceUserCertificationRequirements.getServiceUserCertificationRequirements($scope.serviceID);
            }).then(function (data) {
                $scope.certificationRequirements = data || $scope.certificationRequirements;
                buildPositionRows();
            }).catch(function (response) {
                $scope.saveError = 'The certification requirements were not saved. Please try again.';
                console.error(response);
            }).finally(function () {
                $scope.saving = false;
            });
        };
    }])
;